<template>
  <div class="input">
    <label
      class="input__label"
      :class="{
        'input__label--as-placeholder': labelAsPlaceholder,
        'input__label--only': !labelAsPlaceholder,
        'input__label--only-mobile': labelType === 'only-mobile',
        'input__label--required': required
      }"
      v-if="label"
      :for="getInputId()"
    >
      {{ label }}
    </label>
    <div
      class="input__wrapper"
      :class="{
        'input__wrapper--focus': focus,
        'input__wrapper--error': !!error,
        'input__wrapper--valid': (!error && modelValue)
      }"
    >
      <input
        class="input__field"
        :type="innerType"
        :name="innerName"
        :value="modelValue"
        :placeholder="inputPlaceholder"
        :min="positive ? 0 : ''"
        :max="max"
        :required="required"
        @input="updateValue"
        @change="updateValue"
        @blur="blurHandler"
        @focus="focusHandler"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :aria-label="ariaLabel || null"
        ref="inputField"
        :id="getInputId()"
        :aria-invalid="!!error"
        :aria-errormessage="!!error ? getInputId('-error') : null"
        @keyup="event => $emit('keyUpEvent', {key: event.key})"
      >
      <button
        v-if="type === 'search'"
        :class="[this.focus ? 'input__close-icon__active' : 'input__close-icon__not-active']"
        class="input__close-icon"
        @click.prevent="resetInputValue"
        :aria-label="$t('global.search.close.btn.aria.label')"
        type="button"
      />
      <button
        v-if="button"
        class="input__button"
        :type="button.type"
        :class="[{
          'input__button--default': (button.type && button.type === 'default') || !button.type,
          'input__button--icon_eye': innerType === 'password' && !passwordToggled,
          'input__button--icon_eye-blocked': innerType === 'text' && passwordToggled
        }, buttonIconClass(button.icon)]"
        :aria-label="labelForButton(button.icon)"
        @click.prevent="buttonClickHandler"
      >
        <span
          v-if="button.text"
          class="input__button-text"
        >
          {{ button.text }}
        </span>
      </button>
    </div>
    <span
      :id="getInputId('-error')"
      class="input__error | input-error"
      v-if="!!error"
      v-html="error"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      focus: false,
      innerName: '',
      innerType: 'text',
      passwordToggled: false
    }
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    positive: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    labelType: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    button: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: String,
    max: String,
    ariaLabel: String
  },
  computed: {
    inputPlaceholder() {
      return this.focus ? '' : (this.placeholder || this.label) + (this.required ? ' *' : '')
    },
    labelAsPlaceholder() {
      return !this.placeholder && !this.focus && !this.modelValue
    }
  },
  mounted() {
    this.innerName = this.name
    this.innerType = this.type
  },
  emits: ['update:modelValue', 'blur', 'buttonclicked', 'resetInput', 'keyUpEvent'],
  methods: {
    updateValue(e) {
      if (this.modelValue !== e.target.value) {
        this.$emit('update:modelValue', e.target.value)
      }
    },
    blurHandler() {
      this.focus = false
      this.$emit('blur')
    },
    focusHandler() {
      this.focus = true
    },
    buttonClickHandler() {
      if (this.innerType === 'password' && !this.passwordToggled) {
        this.innerType = 'text'
        this.passwordToggled = true
      } else if (this.innerType === 'text' && this.passwordToggled) {
        this.innerType = 'password'
        this.passwordToggled = false
      } else {
        this.$emit('buttonclicked')
      }
    },
    getValue() {
      return this.value
    },
    buttonIconClass(icon) {
      return icon ? 'input__button--icon_' + icon : ''
    },
    labelForButton(icon) {
      if (icon === 'mail') {
        return this.$t('newsletter.sub.button.label')
      } else if (icon === 'search') {
        return this.$t('search.button.label')
      } else if (this.innerType === 'password' && !this.passwordToggled) {
        return this.$t('password.plain.text.button.label')
      } else if (this.innerType === 'text' && this.passwordToggled) {
        return this.$t('password.hide.text.button.label')
      } else {
        return ''
      }
    },
    resetInputValue() {
      this.$refs.inputField.focus()
      this.$emit('resetInput')
    },
    getInputId(postFix = '') {
      return `input-vue-${this.type}-${this.name}${postFix}`
    }
  }
}

</script>
